import { render, staticRenderFns } from "./CreateConcept.vue?vue&type=template&id=0cbcb386&scoped=true&"
import script from "./CreateConcept.vue?vue&type=script&lang=ts&"
export * from "./CreateConcept.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConcept.vue?vue&type=style&index=0&id=0cbcb386&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbcb386",
  null
  
)

export default component.exports